// STARSTYLOKLEIN - SHOPIFY THEME JS

document.addEventListener('DOMContentLoaded', function() {
  console.log('Starstyloklein theme loaded');
  
  // Initialize smooth scrolling
  initSmoothScroll();
  
  // Mobile navigation
  initMobileNav();
});

// Smooth Scroll Function
function initSmoothScroll() {
  const links = document.querySelectorAll('a[href^="#"]');
  
  links.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const target = document.querySelector(targetId);
      
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
}

// Mobile Navigation
function initMobileNav() {
  const navbar = document.querySelector('.navbar');
  
  if (window.innerWidth <= 768) {
    navbar.style.flexDirection = 'column';
  }
  
  window.addEventListener('resize', function() {
    if (window.innerWidth <= 768) {
      navbar.style.flexDirection = 'column';
    } else {
      navbar.style.flexDirection = 'row';
    }
  });
}

// Cart Functions
function addToCart(productId, quantity = 1) {
  const formData = {
    id: productId,
    quantity: quantity
  };
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    console.log('Product added to cart:', data);
    // Show notification
    showNotification('Product added to cart!');
  })
  .catch(error => {
    console.error('Error:', error);
    showNotification('Error adding to cart', 'error');
  });
}

// Notification System
function showNotification(message, type = 'success') {
  const notification = document.createElement('div');
  notification.className = `notification notification-${type}`;
  notification.textContent = message;
  notification.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: ${type === 'success' ? '#DAA520' : '#ff4444'};
    color: ${type === 'success' ? '#000' : '#fff'};
    padding: 16px 24px;
    border-radius: 4px;
    z-index: 1000;
    animation: slideInUp 0.3s ease;
  `;
  
  document.body.appendChild(notification);
  
  setTimeout(() => {
    notification.remove();
  }, 3000);
}

// Lazy Loading Images
function lazyLoadImages() {
  const images = document.querySelectorAll('img[data-src]');
  
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        observer.unobserve(img);
      }
    });
  });
  
  images.forEach(img => imageObserver.observe(img));
}

// Price Formatter
function formatPrice(price) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(price / 100);
}

// Debounce Function
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Throttle Function
function throttle(func, limit) {
  let inThrottle;
  return function(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}

// Export functions for use in templates
window.ShopifyTheme = {
  addToCart: addToCart,
  showNotification: showNotification,
  lazyLoadImages: lazyLoadImages,
  formatPrice: formatPrice,
  debounce: debounce,
  throttle: throttle
};
